import React, { useState, useEffect, useContext } from "react";
import { Container, Spinner } from "react-bootstrap";
import ActionComp from "../layouts/ActionComp";
import BreadcrumbComp from "../layouts/BreadcrumbComp";
import GridMaster from "./GridMaster";
import StatusRenderer from "./StatusRenderer.jsx";
import ActionRenderer from "./ActionRenderer";
import {
  getAllRoles,
  deleteRole,
  updateRoleId,
} from "../../services/role-service";
import { getUsersForRole } from "../../services/user-service";
import { exportToExcel } from "../utils/ExcelCreation";
import dataMenu from "../../data/sessionmaster.json";
import {
  getCurrentDateTime,
  formatDateInDDMMYYYY,
} from "../../functions/common-functions";
import "react-toastify/dist/ReactToastify.css";
import AddEditRoleMaster from "./AddEditRoleMaster";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import successImage from "../../icons/success-tick-logo.svg";
import errorImage from "../../icons/error-tick-logo.svg";
import { AuthContext } from "../../contexts/AuthContext";
import { menuActions } from "../../store/menu-slice";
import { useDispatch } from "react-redux";
import { sortByPropertyInAscending } from "../../utils/Utility";
import { searchActions } from "../../store/grid-slice";
import { addLogDetails } from "../../services/logger-entry-service";
import { ALERT_PARAMS } from "../../utils/constant.js";

const RoleMaster = () => {
  const MySwal = withReactContent(Swal);
  const context = useContext(AuthContext);
  const userDetails = {
    userName: context.userName,
    role: context.role,
    userId: context.userId,
  };

  const dispatch = useDispatch();
  dispatch(menuActions.setMenu("Role & Authorization Master"));

  const [rowData, setRowData] = useState({});
  const [filteredResult, setFilteredResult] = useState([]);
  const [filteredResulttemp, setFilteredResulttemp] = useState([]);
  const [filterColLength, setFilterColLength] = useState(0);
  const [action, setAction] = useState("");
  const [reload, setReload] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [resetFilter, setResetFilter] = useState(true);
  const [loading, setLoading] = useState(true);

  const columnDefs = [
    {
      headerName: "Status",
      field: "DeleteIndication",
      flex: false,
      width: 150,
      resizable: true,
      tooltipField: "DeleteIndication",
      cellRenderer: StatusRenderer,
      sort: "asc",
    },
    {
      headerName: "Role Code",
      field: "RoleCode",
      width: 150,
      tooltipField: "RoleCode",
    },
    {
      headerName: "Role Description",
      field: "RoleDescription",
      tooltipField: "RoleDescription",
      width: 200,
      sort: "asc",
    },
    {
      headerName: "Session Access",
      field: "AuthorizedSessions",
      width: 300,
      tooltipField: "AuthorizedSessions",
      valueGetter: (params) => {
        if (typeof params.data.AuthorizedSessions === 'string') {
          const sessions = params.data.AuthorizedSessions.split(", ");
          const parentMenus = dataMenu.filter(item => !item.SubMenu && item.ParentMenu !== "Dashboard").map(item => item.ParentMenu);
          const filteredSessions = sessions.filter(session => !parentMenus.includes(session));
          return filteredSessions.join(", ");
        }
        return params.data.AuthorizedSessions;
      }
    },
    {
      headerName: "Inserted By",
      field: "CreatedByName",
      width: 200,
      tooltipField: "CreatedByName",
    },
    {
      headerName: "Inserted On",
      field: "CreatedOn",
      width: 200,
      tooltipField: "CreatedOn",
      valueFormatter: (params) => {
        return params.value
          ? formatDateInDDMMYYYY(params.value.toString())
          : "";
      },
    },
    {
      headerName: "Modified By",
      field: "ModifiedByName",
      width: 200,
      tooltipField: "ModifiedByName",
    },
    {
      headerName: "Modified On",
      field: "ModifiedOn",
      width: 200,
      tooltipField: "ModifiedOn",
      valueFormatter: (params) => {
        return params.value
          ? formatDateInDDMMYYYY(params.value.toString())
          : "";
      },
    },
    context.menuName.includes("Role & Authorization Master") ?
      {
        field: "",
        width: 120,
        cellRenderer: function (params) {
          return <ActionRenderer
            selectedData={params.data}
            handleViewEvent={handleView}
            handleEditEvent={handleEdit}
            handleDeleteEvent={handleDelete} />
        },
        sortable: false,
        filter: false,
        pinned: "right",
        resizable: false,
      } : {},
  ];

  const headerName = (field) => {
    let name;
    switch (field) {
      case "DeleteIndication":
        name = "Role Status";
        break;
      case "RoleCode":
        name = "Role Code";
        break;
      case "RoleDescription":
        name = "Role Description";
        break;
      case "AuthorizedSessions":
        name = "Authorized Sessions";
        break;
      case "CreatedByName":
        name = "Inserted By";
        break;
      case "CreatedOn":
        name = "Inserted On";
        break;
      case "ModifiedByName":
        name = "Modified By";
        break;
      case "ModifiedOn":
        name = "Modified On";
        break;
      default:
        name = "No match found";
        break;
    }
    return name;
  };

  const fieldName = (header) => {
    let name;
    switch (header) {
      case "Status":
        name = "DeleteIndication";
        break;
      case "Role Code":
        name = "RoleCode";
        break;
      case "Role Description":
        name = "RoleDescription";
        break;
      case "Authorized Sessions":
        name = "AuthorizedSessions";
        break;
      case "Inserted By":
        name = "CreatedByName";
        break;
      case "Inserted On":
        name = "CreatedOn";
        break;
      case "Modified By":
        name = "ModifiedByName";
        break;
      case "Modified On":
        name = "ModifiedOn";
        break;
      default:
        name = "No match found";
        break;
    }
    return name;
  };

  const fetchRoleMaster = async () => {
    setLoading(true);
    dispatch(searchActions.setSearch(""));
    const result = await getAllRoles();
    result.forEach((element) => {
      if (Array.isArray(element.AuthorizedSessions)) {
        element.AuthorizedSessions = element.AuthorizedSessions.join(", ");
      }
    });
    result?.sort(sortByPropertyInAscending("DeleteIndication"));
    setFilteredResult(result);
    setExcelData(result);
    setResetFilter(!resetFilter);
    setLoading(false);
  };

  useEffect(() => {
    fetchRoleMaster();
  }, [reload]);

  const handleView = async (row) => {
    setLoading(true);
    const result = await getAllRoles();
    result.forEach(element => {
      if (element.SK === row.SK && element.PK === row.PK)
        row = element;
    });
    setAction("View");
    let tempUnique = "SK#" + row.SK;
    await addLogDetails(row, "View", tempUnique, "RoleMasterLog", userDetails, "Master")
    setRowData(row);
    setShowForm(true);
    setLoading(false);
  }

  const handleEdit = async (row) => {
    setLoading(true);
    const result = await getAllRoles();
    result.forEach((element) => {
      if (element.SK === row.SK && element.PK === row.PK) row = element;
    });
    setAction("Edit");
    let tempUnique = "SK#" + row.SK;
    await addLogDetails(row, "View", tempUnique, "RoleMasterLog", userDetails, "Master")
    setRowData(row);
    setShowForm(true);
    setLoading(false);
  };

  const handleDelete = async (row) => {
    const name = row.RoleDescription || row.RoleName;
    let tempUnique = "SK#" + row.SK;
    let result;
    MySwal.fire({
      text: "Are you sure, do you want to delete Role " + name + "?",
      confirmButtonText: "Delete",
      title: "Delete Role",
      ...ALERT_PARAMS,
    }).then(async (result2) => {
      if (result2.isConfirmed) {
        setLoading(true);

        let userList = await getUsersForRole(row.RoleCode);
        let activeUsers = userList?.filter((item) => item.DeleteIndication === "Active") || [];

        if (row.DeleteIndication === "Inactive") {
          // If status is Inactive, permanently delete
          result = deleteRole(row.SK);
          result.then(async (resp) => {
            if (resp.status) {
              await addLogDetails(row, "Delete", tempUnique, "RoleMasterLog", userDetails, "Master");
              setLoading(false);
              MySwal.fire({
                text: "The Role is Permanently Deleted!",
                imageUrl: successImage,
                customClass: "swal-success",
                didClose: () => {
                  setReload(!reload);
                },
              });
            }
          })
            .catch((error) => {
              setLoading(false);
              MySwal.fire({
                text: "Unable to process request.",
                imageUrl: errorImage,
                customClass: "swal-success",
              });
            });
        } else if (activeUsers.length > 0) {
          // If role is assigned to active users, cannot delete
          setLoading(false);
          MySwal.fire({
            text: "Role is assigned to user. Cannot be deleted",
            imageUrl: errorImage,
            customClass: "swal-success",
          });
        } else {
          // If role is not assigned to any user, change status to Inactive
          let roleObj = { ...row };
          let todayDate = getCurrentDateTime("-");
          roleObj.ModifiedBy = userDetails.userId;
          roleObj.ModifiedByName = userDetails.userName;
          roleObj.ModifiedOn = todayDate;
          roleObj.DeleteIndication = "Inactive";
          result = updateRoleId(roleObj);
          result.then(async (resp) => {
            if (resp.status) {
              await addLogDetails(row, "Delete", tempUnique, "RoleMasterLog", userDetails, "Master");
              setLoading(false);
              MySwal.fire({
                text: "Role status changed to Inactive.",
                imageUrl: successImage,
                customClass: "swal-success",
                didClose: () => {
                  setReload(!reload);
                },
              });
            }
          })
            .catch((error) => {
              setLoading(false);
              MySwal.fire({
                text: "Unable to process request.",
                imageUrl: errorImage,
                customClass: "swal-success",
              });
            });
        }
      }
    });
  };

  const handleGlobalExport = async () => {
    let filename = "Rolemaster";
    let excelDownoadData = [];

    excelData.forEach(element => {
      let dataEntry = {
        DeleteIndication: element.DeleteIndication,
        RoleCode: element.RoleCode,
        RoleDescription: element.RoleDescription,
        AuthorizedSessions: element.AuthorizedSessions,
        CreatedByName: element.CreatedByName,
        CreatedOn: element.CreatedOn
          ? formatDateInDDMMYYYY(element.CreatedOn.toString())
          : "",
        ModifiedByName: element.ModifiedByName,
        ModifiedOn: element.ModifiedOn
          ? formatDateInDDMMYYYY(element.ModifiedOn.toString())
          : "",
      };
      excelDownoadData.push(dataEntry);
    });

    let colName = ["Role Status", "Role Code", "Role Description", "Session Access", "Inserted By", "Inserted On", "Modified By", "Modified On"];
    let Fieldname = ["DeleteIndication", "RoleCode", "RoleDescription", "AuthorizedSessions", "CreatedByName", "CreatedOn", "ModifiedByName", "ModifiedOn"];
    exportToExcel(filename, "Data", excelDownoadData, "A1:H1", colName, Fieldname);
  };

  const handleAdd = () => {
    setAction("Add");
    setShowForm(true);
  };

  return (
    <>
      {loading && (
        <div className="spinner-box">
          {" "}
          <Spinner animation="border" className="spinner" />
        </div>
      )}
      <BreadcrumbComp />
      <Container fluid className="main-container">
        <ActionComp
          label={"Add New Role"}
          exportEvent={() => handleGlobalExport()}
          handleAdd={handleAdd}
        />

        <GridMaster
          rowDetails={filteredResult}
          colDetails={columnDefs}
          fieldNames={fieldName}
          headerNames={headerName}
          getDataEvent={(getFilteredData) =>
            setFilteredResulttemp(getFilteredData)
          }
          getFilterColLength={(getLength) => setFilterColLength(getLength)}
          setExcelData={setExcelData}
          handleView={handleView}
          handleEdit={handleEdit}
          openConfirmBox={handleDelete}
          resetind={resetFilter}
        />
        {showForm && (
          <AddEditRoleMaster
            show={showForm}
            action={action}
            rowdata={rowData}
            onHide={() => setShowForm(false)}
            setreload={setReload}
            reload={reload}
          />
        )}
      </Container>
    </>
  );
};

export default RoleMaster;
